var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.copyContent}},[_vm._t("default",function(){return [_c('z-icon',{attrs:{"icon":_vm.btnIcon,"size":_vm.iconSize,"color":_vm.iconColor}}),_vm._v("\n    "+_vm._s(_vm.btnLabel)+"\n  ")]},{"hasCopied":_vm.hasCopied})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }